$bog_testops_app $mol_book2_catalog
	realm <= Realm $hyoo_crus_glob
	Placeholder null
	Menu_logo $mol_image
		uri \bog/testops/assets/favicon.ico
	menu_title @ \TestOps Copilot
	menu_tools /
		<= Theme_toggle $bog_theme_toggle
			theme_auto <= Theme
		<= Sources $mol_link_source
			uri \https://github.com/best-online-games/bog/tree/master/testops
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_light
			theme_dark \$mol_theme_dark
	spreads *
		generator <= Generator $bog_testops_app_generator
		library <= Library $bog_testops_app_library
		optimizer <= Optimizer $bog_testops_app_optimizer
		validator <= Validator $bog_testops_app_validator
		settings <= Settings $bog_testops_app_settings
